module.exports = __webpack_public_path__ + "static/img/product_4.dab060ec.png";